import { IconWrapper } from '../runtime';
export default IconWrapper('cell-phone', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6.75 11.7498H9.25M4.5 14.2498H11.5C12.3284 14.2498 13 13.5782 13 12.7498V3.24982C13 2.42139 12.3284 1.74982 11.5 1.74982H4.5C3.67157 1.74982 3 2.42139 3 3.24982V12.7498C3 13.5782 3.67157 14.2498 4.5 14.2498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});